import React from 'react';
import { Link } from 'react-router-dom';
import { PageHeader } from '../../../shared/components/PageHeader';
import { useDocumentTitle } from '../../../shared/hooks/useDocumentTitle';
import { useAuth } from '../../../contexts/AuthContext';

export function HomePage(): React.ReactElement {
  const { isAuthenticated, user, login, azureAuthConfigured } = useAuth();
  useDocumentTitle('Triplicity Backoffice');

  if (isAuthenticated && user) {
    return (
      <div className="bo-home">
        <PageHeader
          title="Welcome"
          subtitle={`Signed in as ${user.displayName}`}
        />
        <div className="bo-card" style={{ maxWidth: '36rem' }}>
          <p style={{ marginTop: 0, marginBottom: '0.75rem' }}>
            You are signed in and can use every part of the app.
          </p>
          <p style={{ margin: 0 }}>
            Open{' '}
            <Link to="/merchants">Merchants</Link> to manage records, or{' '}
            <Link to="/merchants/invite">Invite merchant</Link> to send invitations.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="bo-home-landing">
      <div className="bo-home-landing-inner">
        <h1 className="bo-home-title">Triplicity Backoffice</h1>
        <p className="bo-home-lead">
          Sign in with your work account to manage merchants, review data, and send invitations.
        </p>
        <ol className="bo-home-steps">
          <li>Click <strong>Sign in</strong> below (or use the button in the header).</li>
          <li>Complete sign-in with Microsoft (Entra ID).</li>
          <li>After that, use the navigation to open Merchants or other tools.</li>
        </ol>
        <div className="bo-home-cta-row">
          <button type="button" className="bo-btn bo-btn-primary bo-home-cta" onClick={login}>
            {azureAuthConfigured ? 'Sign in with Microsoft' : 'Continue (stub sign-in)'}
          </button>
        </div>
        <p className="bo-home-note">
          {azureAuthConfigured
            ? 'If you have trouble signing in, confirm this app’s redirect URI is registered in your Entra app registration and that your account is allowed to use it.'
            : 'Azure is not configured for this build. Set REACT_APP_AZURE_CLIENT_ID and REACT_APP_AZURE_TENANT_ID for Microsoft sign-in, or use REACT_APP_AUTH_STUB=true for local stub sign-in.'}
        </p>
      </div>
    </div>
  );
}
